export default __webpack_public_path__ + "static/media/Peak-Noise-BW-0.1.79bef002.jpg";